//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { mapState } from "vuex"; //切割状态
export default {
  name: "App",
  computed: {
    ...mapState(["title"])
  }
};



// WEBPACK FOOTER //
// ./src/App.vue